import React from "react";

export default () => (
  <div className="not-found">
    <h1>404 NOT FOUND!</h1>
    <p>주소를 다시 확인해 주세요</p>
  </div>
);
